import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appFormatCurrency]'
})
export class FormatCurrencyDirective {
  constructor(private renderer: Renderer2, private element: ElementRef) { }

  @HostListener('input', ['$event']) onInput(el) {
    this.renderer.setProperty(this.element.nativeElement, 'value', this.formatarMoeda(el.target));
  }

  private formatarMoeda(valor) {
	var v = valor.value.replace(/\D/g,'');
	v = (v/100).toFixed(2) + '';
	v = v.replace(".", ",");
	v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
	v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
	valor.value = v;
    return valor.value;
  }
  
}